module.exports = (timer) => {
    return new Promise ((r, j) => {
        setTimeout (() => r (), timer || 100)
    })
}